import { useContext } from 'react';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { isTouch } from './browser';

/** Returns true for mobile -and- tablets */
function useIsMobileOrTouch(): boolean {
  const isMobile = useContext(MobileContext);
  return isMobile || isTouch();
}
export default useIsMobileOrTouch;
